/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useCancelRecurringProfile = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.cancelRecurringProfile(id),
    mutationFn: () => fetcher({ method: "DELETE", url: `/public/invoice/recurring-profile/id/${id}` }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.recurringProfiles.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.purchasedMemberships.all });
    },
  });
};
